import React from "react";
import omit from "@/utils/omit";
import { IconProps } from "../interface";

const IconAiRewrite = React.forwardRef<SVGSVGElement, IconProps>(
  (props, ref) => (
    <svg
      width="10"
      height="11"
      viewBox="0 0 10 11"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      ref={ref}
      {...omit(props, ["className"])}
      className="yfm-icon yfm-icon-ai-rewrite"
    >
      <path
        d="M7.67525 0H2.32475C1.04302 0 0 1.04302 0 2.32475V8.16144C0 9.44318 1.04302 10.4862 2.32475 10.4862H7.67525C8.95698 10.4862 10 9.44318 10 8.16144V2.32475C10 1.04302 8.95698 0 7.67525 0ZM7.67525 9.72801H2.32475C1.46092 9.72801 0.75877 9.02527 0.75877 8.16203V2.32475C0.75877 1.46092 1.46151 0.75877 2.32475 0.75877H7.67525C8.53908 0.75877 9.24123 1.46151 9.24123 2.32475V8.16144C9.24123 9.02527 8.53849 9.72743 7.67525 9.72743V9.72801Z"
        fill="#17215C"
      />
      <path
        d="M7.52703 7.89062H2.47362C2.26467 7.89062 2.09424 8.06106 2.09424 8.27001C2.09424 8.47896 2.26467 8.64939 2.47362 8.64939H7.52703C7.73598 8.64939 7.90641 8.47896 7.90641 8.27001C7.90641 8.06106 7.73598 7.89062 7.52703 7.89062Z"
        fill="#17215C"
      />
      <path
        d="M3.37153 7.11527C3.42406 7.11527 3.47717 7.1106 3.53087 7.10126L4.41221 6.95068L4.42388 6.94893C4.53536 6.92675 4.64217 6.88764 4.73965 6.83394C4.84237 6.78083 4.93518 6.71137 5.01631 6.62733L7.28153 4.2302C7.56811 3.92727 7.71811 3.63135 7.73971 3.32493C7.76597 2.94963 7.59612 2.58542 7.236 2.24105L7.22433 2.22938C6.8572 1.88443 6.48073 1.73385 6.10543 1.78229C5.80192 1.82081 5.51476 1.98657 5.22818 2.2895L2.96121 4.68954C2.87307 4.78293 2.81121 4.89616 2.7756 4.97379C2.73941 5.05084 2.69272 5.16874 2.67638 5.29598L2.57307 6.19599V6.20241C2.5433 6.47382 2.63144 6.7283 2.81354 6.90048C2.96062 7.04056 3.15849 7.11527 3.37153 7.11527ZM3.32659 6.28121L3.42873 5.39345C3.43048 5.38002 3.44157 5.34209 3.46375 5.29364C3.47717 5.26271 3.49468 5.23411 3.51628 5.20784L5.78033 2.81188C5.93909 2.64437 6.08092 2.55098 6.20232 2.53581C6.3424 2.51771 6.51167 2.60118 6.70486 2.78328C6.89981 2.96714 6.99319 3.13173 6.98327 3.27356C6.97452 3.39555 6.88988 3.54264 6.73054 3.71015L4.46357 6.1102C4.44023 6.13237 4.41396 6.15047 4.38186 6.16681C4.35267 6.18315 4.32116 6.19541 4.28906 6.20358L3.40305 6.35534C3.36044 6.36292 3.34059 6.35534 3.33767 6.35242C3.33767 6.35242 3.3225 6.33607 3.32775 6.28238L3.32659 6.28121Z"
        fill="#17215C"
      />
    </svg>
  )
);

IconAiRewrite.displayName = "IconAiRewrite";

export default IconAiRewrite;
